module.exports = __webpack_public_path__ + "img/EAxeman64_ua.ca851b21.webp";